import { useCallback, useMemo } from 'react';
import PropTypes from 'prop-types';
import Badge from '@mui/material/Badge';
import Link from '@mui/material/Link';
import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';
import { toLower } from 'ramda';
import { useNavigate } from 'react-router-dom';

import { gtmDashboardSectionNames } from 'features/views/dashboard/constants';
import { useButtonClickDataLayer } from 'features/views/dashboard/hooks';
import { joinString } from 'utils/string';

export const CampaignTableRow = ({ campaign }) => {
	const navigate = useNavigate();

	const campaignName = joinString(' ', [campaign?.campaignName, campaign?.communicationName]);

	const pushToClickButtonDataLayer = useButtonClickDataLayer();

	const handleRedirect = useCallback(() => {
		pushToClickButtonDataLayer({
			value: gtmDashboardSectionNames.CAMPAIGNS,
			button_text: toLower(campaignName),
		})();

		navigate({
			pathname: '/contacts',
			search: `?campaignId=${campaign?.id}`,
		});
	}, [campaign?.id, campaignName, pushToClickButtonDataLayer, navigate]);

	const colorConfigBasedOnRemainingDays = useMemo(() => {
		const percentageLeft = Math.floor((campaign?.daysToEnd / campaign?.daysTotal) * 100);
		if (percentageLeft < 25) {
			return {
				backgroundColor: 'primary.main',
				color: 'common.white',
			};
		} else {
			return { backgroundColor: 'grey.200', color: 'common.black' };
		}
	}, [campaign?.daysToEnd, campaign?.daysTotal]);

	return (
		<TableRow>
			<TableCell>
				<Link underline="none" onClick={handleRedirect} sx={{ cursor: 'pointer' }}>
					{campaignName}
				</Link>
			</TableCell>
			<TableCell just align="right">
				<Badge
					badgeContent={campaign?.daysToEnd}
					color="success"
					max={100000}
					sx={{
						marginRight: 2,
						'& .MuiBadge-anchorOriginTopRight': {
							...colorConfigBasedOnRemainingDays,
						},
					}}
				/>
			</TableCell>
		</TableRow>
	);
};

CampaignTableRow.propTypes = {
	campaign: PropTypes.object,
};

export default CampaignTableRow;
